import { lsGet, lsSave, lsRemove } from '@/utils/localStorageController'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import customerIncompleteHandler from '@/mixins/customerIncompleteHandler'
import { differenceInMinutes } from 'date-fns'

const MENU_LS_KEY = 'sc_menu_'
export default {
  data () {
    return {
      menuItems: [],
      sidebarLoading: false
    }
  },
  mixins: [errorMessageHandler, customerIncompleteHandler],
  methods: {
    getSidebarMenuItems (section, forceRefresh = false) {
      const storedMenu = lsGet(MENU_LS_KEY + section) || {}
      if (!storedMenu.timestamp) {
        this.fetchSidebarMenuFromService(section)
        return
      }
      if (storedMenu.timestamp && !forceRefresh) {
        const timeDiff = differenceInMinutes(new Date(), new Date(storedMenu.timestamp))
        if (timeDiff >= 5) {
          this.fetchSidebarMenuFromService(section)
        } else {
          this.menuItems = storedMenu.menu
        }
      } else {
        this.fetchSidebarMenuFromService(section)
      }
    },
    fetchSidebarMenuFromService (section) {
      this.sidebarLoading = true
      this.$apiRequest.get(`user/${section}`)
        .then(response => {
          this.menuItems = response.data.menuItems
          this.storeSidebarMenu(section, { timestamp: new Date().getTime(), menu: response.data.menuItems })
          lsRemove('sc_incomplete_customer_try_count')
        })
        .catch(e => {
          // TODO handleErrorMessage mixin bi trebalo da sada radi ovo isto, proveriti pa ostaviti samo mixin da hendluje gresku
          if (e.response && e.response.data && e.response.data.errors[0].type === 'MtmCustomerInfoUpdateNotCompleteError') {
            this.handleIncompleteCustomer()
          } else {
            this.handleErrorMessage(e.response.data)
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.sidebarLoading = false
          })
        })
    },
    storeSidebarMenu (section, data) {
      lsSave(MENU_LS_KEY + section, data)
    }
  }
}
